var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-description"},[_c('span',{staticClass:"base-description__label"},[_vm._v(" "+_vm._s(_vm.label)),(_vm.colon)?[_vm._v("：")]:_vm._e()],2),_c('div',{staticClass:"base-description__value"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }